<div class="admin admin-page admin-page-school-classes">

  <div class="page-header">
    <h2 class="page-title">
      {{'Classes' | translate}}
      <small *ngIf="schoolName" class="text-muted"> - {{schoolName}}</small>
    </h2>
  </div>

  <div class="btn-toolbar mb-3">
    <a routerLink="/admin/schools" class="btn btn-outline-secondary mr-2">
      &larr; {{'Back to schools' | translate}}
    </a>
    <button class="btn btn-primary ml-auto" (click)="addClass()">
      {{'Add' | translate}}
    </button>
  </div>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</div>
